function KnownLocationCard() {
    "use strict";
    this.Id = -1;
    this.OrganizationAddressTypeId = -1;
    this.City = '';
    this.Country = '';
    this.State = '';
    this.Street1 = '';
    this.Street2 = '';
    this.Title = '';
    this.Zip = '';
    this.Latitude = 0.00;
    this.Longitude = 0.00;
    this.OrganizationName = '';
    this.Radius = 0;
}
if (typeof exports !== 'undefined') {
    module.exports = KnownLocationCard;
}